import { useRouter } from 'next/router';
import { useEffect } from 'react';

const updateViewContext = () => {
  const IS_NEXT_SERVER = process.env.IS_EXPORT === 'false';

  window.DD_RUM &&
    window.DD_RUM.onReady(() => {
      window.DD_RUM.setViewContextProperty('server', IS_NEXT_SERVER ? 'Next.js' : 'PHP');
      if (window.__i18nLocale) window.DD_RUM.setViewContextProperty('locale', window.__i18nLocale);

      // We need to set the `isLoggedIn` property globally instead of on a per-view basis because logged in users
      // might navigate to pages where the PHP TemplateController isn't available to set the user attributes.
      // This would cause a session to appear as though the user was briefly logged out.
      const isLoggedIn = window.DD_RUM.getUser()?.id && window.DD_RUM.getUser()?.id !== '0';
      window.DD_RUM.setGlobalContextProperty('isLoggedIn', isLoggedIn ? 'true' : 'false');
    });
};

export const useDatadogPageTracking = () => {
  const router = useRouter();

  // The 'routeChangeComplete' event listener doesn't fire on initial page load.
  // Therefore, a workaround is to use useEffect(() => {}, []) for the initial load
  // and then 'routeChangeComplete' for subsequent client-side navigation.

  useEffect(() => {
    updateViewContext();
  }, []);

  useEffect(() => {
    router.events.on('routeChangeComplete', updateViewContext);

    return () => {
      router.events.off('routeChangeComplete', updateViewContext);
    };
  }, [router]);
};
